import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-map-tool',
    templateUrl: './map-tool.component.html',
    styleUrls: ['./map-tool.component.scss'],
    standalone: false
})
export class MapToolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
